import styled from "styled-components";
import { accentColor } from "./style";
import { useState } from "react";
import { bodyTextRegular, bodyTextBold } from "./style";
import { breakpoint } from "./style";

const TrailerVideoContainer = styled.div`
    width: 100%;
    margin: 0px;
    padding: 100px 120px 100px 120px;

    @media ${breakpoint.tablet} {

        padding: 0px;

    }

    @media ${breakpoint.phone} {
    
    }

`;

const SeeMoreLink = styled.div`
    text-align: right;
    width: 100%;
    margin: 10px 0px;
    font-weight: 700;
    color: ${accentColor};
    cursor: pointer;
    font-size: 14pt;

    &:hover {
        text-shadow: 2px 2px 3px #e0e0e0;

    }
`;

const FullScreenContainerDiv = styled.div`
    position: fixed;
    top: 0px;
    // left: 10%;
    // width: 90%;
    height: 100vh;
    // overflow-y: scroll;
    z-index: 5000;
    background-color: rgba(255,255,255,0.99);
    border-left: 1px solid #FFFFFF;
    left: 0;
    width: 100%;
    opacity: 0;
    display: flex;
    flex-direction: column;

    transition: left 0.5s, opacity 0.5s;
    transition-timing-function: ease;

    &.open {
        opacity: 1;
        pointer-events: all;
    }

    &.closed {
        opacity: 0;
        pointer-events: none;
    }

`;

const FullScreenVideoContainer = styled.div`
    width: 75%;
    margin: auto;
`;

const divStyle = {
    padding: "56.25% 0 0 0",
    position: "relative"
};

const iframeStyle = {
    position: "absolute",
    top: 0,
    left:0,
    width: "100%",
    height: "100%",
    borderRadius: "20px",
    boxShadow: "5px 5px 8px #c0c0c0"

};

const CloseTab = styled.div`
    ${bodyTextRegular}
    margin: 0px;
    margin-left: 60px;
    margin-top: 20px;
    margin-bottom: 10px;
    padding: 0px;
    cursor: pointer;
    color: #333333;
    font-size: 12pt;

    &:hover {
        ${bodyTextBold}
    }
`;

const ProcessFilm = ({showFullScreenContainer, handleClose}) => {

    return <FullScreenContainerDiv className={showFullScreenContainer == true ? "open" : "closed"}>
        <CloseTab onClick={() => handleClose()}>✕ Close and return to previous</CloseTab>
        <FullScreenVideoContainer>
        <div style={divStyle}><iframe src="https://player.vimeo.com/video/949704919?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={iframeStyle} title="&quot;Proxies&quot; Process Film (2024)"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
        </FullScreenVideoContainer>
    </FullScreenContainerDiv>
}

const TrailerVideo = ({setSectionIsExpanded}) => {

    const [showFullScreenContainer, setShowFullScreenContainer] = useState(false);


    const handleOpen = () => {
        setShowFullScreenContainer(true);
        setSectionIsExpanded(true);
    }

    const handleClose = () => {
        setShowFullScreenContainer(false);
        setSectionIsExpanded(false);
    }


    return <>
        <TrailerVideoContainer>
            <div style={divStyle}><iframe src="https://player.vimeo.com/video/882076757?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={iframeStyle} title="&quot;Proxies&quot; @ Jacob's Pillow (Trailer)"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
            <SeeMoreLink onClick={() => handleOpen()}>See more in<br />the <i>Proxies</i> Process Film &rarr;</SeeMoreLink>
        </TrailerVideoContainer>
        <ProcessFilm showFullScreenContainer={showFullScreenContainer} handleClose={handleClose}/>
    </>
}

export default TrailerVideo;